import React from 'react';
import optionsRangeFilterStyles from '@/components/filters/OptionsRangeFilter/OptionsRangeFilter.module.css';
import statusFilterStyles from '@/components/filters/StatusFilter/StatusFilter.module.css';
import icClose from '@/assets/icons/close.svg';

export type TagFilterVariant = 'options-range-filter-style' | 'status-filter-style';

interface TagFilterProps {
  title: string;
  onClose?: () => void;
  variant?: TagFilterVariant;
}

const getStyles = (variant?: TagFilterVariant) => {
  switch (variant) {
    case 'options-range-filter-style':
      return optionsRangeFilterStyles;
    case 'status-filter-style':
      return statusFilterStyles;
    default:
      return optionsRangeFilterStyles;
  }
};

const getTextClassName = (variant?: TagFilterVariant) => {
  switch (variant) {
    case 'options-range-filter-style':
      return 'body-sm-regular text-(--font-primary)';
    case 'status-filter-style':
      return 'body-sm-semibold text-(--font-body-1)';
    default:
      return 'body-sm-regular text-(--font-primary)';
  }
};

export const TagFilter: React.FC<TagFilterProps> = ({ title, onClose, variant }) => {
  const styles = getStyles(variant);
  const textClassName = getTextClassName(variant);

  return (
    <div className={`${styles.filterButton} ${styles.filterButtonHasValue}`}>
      <span className={textClassName}>{title}</span>
      {onClose && <img src={icClose} alt="remove filter" className={styles.closeIcon} onClick={() => onClose()} />}
    </div>
  );
};

export default TagFilter;
